/**
 * How a measured value prints.
 *
 * One function, because every drawing on the page prints the same numbers and
 * the reader compares them across drawings: a share that reads 40% in the
 * table and 0.4 in the matrix looks like two different results. The unit comes
 * from the result column the compiler labelled, so a measure authored later
 * prints correctly without anything here changing.
 */
export function show(v: unknown, unit?: string | null): string {
  if (v === null || v === undefined) return '—'
  if (typeof v === 'number') {
    const n = Number.isInteger(v) ? String(v) : v.toFixed(3)
    return unit === 'fraction' ? `${(v * 100).toFixed(1)}%` : n
  }
  return String(v)
}
